import BackButton from '@acorn-portal/shared/src/components/buttons/BackButton';
import ContinueButton from '@acorn-portal/shared/src/components/buttons/ContinueButton';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { useNavigate } from 'react-router';

type ActionButtonProps = { disableSubmit: boolean; handleSubmit: () => void };

const ActionButtons = ({ disableSubmit, handleSubmit }: ActionButtonProps) => {
	const navigate = useNavigate();
	const [showBackModal, setShowBackModal] = useState<boolean>(false);

	return (
		<>
			<Box
				sx={{
					gap: 2,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					width: '100%',
				}}
			>
				<BackButton onClick={() => setShowBackModal(true)}>Back</BackButton>
				<ContinueButton onClick={handleSubmit} disabled={disableSubmit}>
					Continue
				</ContinueButton>
			</Box>
			<HelperModal
				open={showBackModal}
				onClose={() => {
					setShowBackModal(false);
				}}
				title='Discard The Changes?'
				description='Are you sure you wish to discard the changes?'
				closeText='No'
				submitText='Yes'
				onSubmit={() => navigate(-1)}
			/>
		</>
	);
};

export default ActionButtons;
